<!--OfficialMobile:官网移动端父路由 2021/12/20 09:31:52 YuAng-->

<template>
  <div class="its-auto-fit">
    <mobile-header></mobile-header>
    <div class="ho-mobile-page">
      <router-view></router-view>
      <mobile-footer v-if="!$route.meta.hiddenFooter"></mobile-footer>
    </div>
  </div>
</template>
<script>
import MobileFooter from './components/MobileFooter.vue'
import MobileHeader from './components/MobileHeader.vue'
export default {
  components: { MobileHeader, MobileFooter },
  name: 'OfficialMobile'
}
</script>

<style scoped>
.ho-mobile-page {
  padding-top: 53px;
  height: 100%;
}

.ho-mobile-page >>> .ho-part-title {
  font-size: 16px;
  font-weight: bold;
  padding: 16px;
  text-align: center;
}
</style>